import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import { Grid, Row, Col } from 'react-flexbox-grid';
import accountRules from '../../../common/rules/accountRules';

const { Item: FormItem } = Form;

@translate()
@Form.create()
export default class ForgottenPasswordForm extends Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  handleSubmit = e => {
    e.preventDefault();

    const { form, onSubmit } = this.props;

    form.validateFields((err, values) => {
      if (!err) {
        onSubmit(values);
      }
    });
  };

  render() {
    const { form, t } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Grid className="auth-wrapper">
        <Row around="xs">
          <Col xs={12} sm={6}>
            <h2>{t('Zabudnuté heslo')}</h2>
            <Form layout="vertical" onSubmit={this.handleSubmit} hideRequiredMark>
              <FormItem label={t('E-mail')}>
                {getFieldDecorator('email', { rules: accountRules.email })(
                  <Input size="default" placeholder={t('E-mail')} autoFocus type="email" />
                )}
              </FormItem>
              <Row between="xs" middle="xs" className="form-actions">
                <Col xs={12} sm={6}>
                  <Button type="primary" htmlType="submit" size="default">
                    {t('Požiadať o nové heslo')}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/auth/components/ForgottenPasswordForm.js